import React from 'react';
import { languageDirection } from '../../i18n';

const LoadingCircleIndicator = (style?: any) =>
  languageDirection() === 'ltr' ? (
    <div className="center-vh" style={{ padding: '4rem', ...style }}>
      <div className="preloader-wrapper small active">
        <div className="spinner-layer spinner-green-only">
          <div className="circle-clipper left">
            <div className="circle" />
          </div>
          <div className="gap-patch">
            <div className="circle" />
          </div>
          <div className="circle-clipper right">
            <div className="circle" />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="center-vh" style={{ padding: '4rem', ...style }}>
      <div className="preloader-wrapper small active">
        <div className="spinner-layer spinner-green-only">
          <div className="circle-clipper right">
            <div className="circle" />
          </div>
          <div className="gap-patch">
            <div className="circle" />
          </div>
        </div>
      </div>
    </div>
  );

export const LoadingCircleIndicatorNoPad: React.FC<any> = ({
  style,
  innerStyle,
}) =>
  languageDirection() === 'ltr' ? (
    <div className="center-vh" style={{ ...style }}>
      <div className="preloader-wrapper small active" style={{ ...innerStyle }}>
        <div className="spinner-layer spinner-green-only">
          <div className="circle-clipper left">
            <div className="circle" />
          </div>
          <div className="gap-patch">
            <div className="circle" />
          </div>
          <div className="circle-clipper right">
            <div className="circle" />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="center-vh" style={{ ...style }}>
      <div className="preloader-wrapper small active" style={{ ...innerStyle }}>
        <div className="spinner-layer spinner-green-only">
          <div className="circle-clipper right">
            <div className="circle" />
          </div>
          <div className="gap-patch">
            <div className="circle" />
          </div>
        </div>
      </div>
    </div>
  );

export default React.memo(LoadingCircleIndicator);
